<template>
    <div class="header">
        <div class="logo" @click="$router.push('/home')">
            <img :src="logoUrl" alt="未找到图片">
        </div>

        <div class="menu" v-show="!showPhoneMenu">
            <div class="menu-item" @click="$router.push('/home')" @mouseenter="handleMouseEnter('0')"
                 @mouseleave="handleMouseLeave('0')">首页
            </div>
            <div class="menu-item" @mouseenter="handleMouseEnter('1')" @mouseleave="handleMouseLeave('1')">产品</div>
            <div class="menu-item" @mouseenter="handleMouseEnter('2')" @mouseleave="handleMouseLeave('2')"
                 @click="goRoute('/solution')">解决方案
            </div>
            <!-- <div class="menu-item" @mouseenter="handleMouseEnter('3')" @mouseleave="handleMouseLeave('3')">课程</div> -->
            <div class="menu-item" @mouseenter="handleMouseEnter('4')" @mouseleave="handleMouseLeave('4')"
                 @click="goRoute('/customerCase')">客户案例
            </div>
            <div class="menu-item" @mouseenter="handleMouseEnter('5')" @mouseleave="handleMouseLeave('5')"
                 @click="goRoute('/parterPlanUnderstand')">合作伙伴计划
            </div>
        </div>

        <div class="menu" v-if="showPhoneMenu" id="over-box">
            <div class="right-icon-fold" @click="showPhoneContent" v-if="!isFold">
                <el-icon class="el-icon-s-unfold" v-if="isFold"></el-icon>
                <el-icon class="el-icon-s-fold" v-else></el-icon>
            </div>
        </div>

        <el-collapse-transition>
            <div class="menu-phone-content" v-if="isFold" @touchmove.prevent>
                <div class="right-icon-fold" style="text-align: right;" @click="showPhoneContent">
                    <el-icon class="el-icon-s-unfold"></el-icon>
                </div>
                <div class="menu-phone-content-wrapper">
                    <div v-for="(item, index) in meneNames" :key="index">
                        <div class="menu-phone-content-wrapper-item" @click="clickPhoneMenuNames(item, index)">
                            <span>{{ item.name }}</span>
                            <transition name="el-fade-in-linear">
                                <i v-if="item.name != '产品'" class="el-icon-arrow-right desc-icon"></i>
                            </transition>
                        </div>
                        <div v-if="item.name == '产品'" class="menu-phone-content-wrapper-item-child">
                            <div v-for="(v, index) in productMenuList" :key="index"
                                 @click="clickPhoneMenuNames(v, index)">
                                <span>{{ v.name }}</span>
                                <transition name="el-fade-in-linear">
                                    <i class="el-icon-arrow-right desc-icon"></i>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="menu_mao_phone"></div>
            </div>
        </el-collapse-transition>

        <div class="menu-content" id="menu_content">
            <div id="menu_content_fir">
                <div v-for="(item, index) in menuList" :key="index" class="menu-child-item"
                     @click="goRoute(item.route)">
                    <div v-if="item.img" style="height: 180px; margin-bottom: 15px;">
                        <img :src="item.img" alt="" style="width: auto; height: 180px;">
                    </div>
                    <div class="menu-child-name">{{ item.name }}</div>
                    <div v-if="item.subText" class="menu-child-subtext">{{ item.subText }}</div>
                </div>
            </div>
            <div id="menu_mao"></div>
        </div>

        <div style="height: 100vh; background-color: burlywood;"></div>
    </div>
</template>

<script>

export default {
    name: 'headerMenu',
    data() {
        return {
            logoUrl: require('../assets/images/logo.svg'),
            menuList: [],
            productMenuList: [
                // { name: 'AI就业平台', img: '', route: '' },
                {
                    name: '生涯发展工具系列',
                    img: require('../assets/images/home/work.png'),
                    route: '/careerDevelopUtilsPro'
                },
                {name: 'AI面试亭', img: require('../assets/images/home/qj.png'), route: '/aiInterviewPro'},
                {name: 'AI面试一体机', img: require('../assets/images/home/ms.png'), route: '/aiInterviewAllPro'},
                {name: 'AI生涯互动台', img: require('../assets/images/home/hd.png'), route: '/aiCareerPro'},
                {name: 'VR职业体验一体机', img: require('../assets/images/home/vr.png'), route: '/vrCareerExpPro'},
            ],
            solveMenuList: [],
            courseMenuList: [
                {name: '师资认证', subText: '生涯规划与就业指导能力提升', img: '', route: ''},
                {name: '宇乐星辰训练', subText: '大学生职业规划与就业能力提升', img: '', route: ''},
                {name: '职规大赛', subText: '职规大赛辅导与教学能力提升', img: '', route: ''},
                {name: 'K12课程服务', subText: '', img: '', route: ''},
            ],
            customerMenuList: [],
            aboutMenuList: [
                {name: '了解宇乐树', img: '', route: ''},
                {name: '宇乐树生涯科技研究所', img: '', route: ''},
                {name: '合作伙伴计划', img: '', route: ''},
                {name: '加入我们', img: '', route: ''},
            ],
            isFold: false,
            showPhoneMenu: false,
            activeNames: ['1'],
            meneNames: [
                {name: '首页', route: '/home'},
                {name: '产品', route: ''},
                {name: '解决方案', route: '/solution'},
                {name: '客户案例', route: '/customerCase'},
                {name: '合作伙伴计划', route: '/parterPlanUnderstand'},
            ],
        }
    },

    mounted() {
        this.init()
    },

    watch: {
        isFold() {
            if (this.isFold) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'auto'
            }
        }
    },

    methods: {
        init() {

            this.watchViewResize()

            let el = document.getElementsByClassName("menu-item");
            let content = document.getElementById("menu_content");
            let firContent = document.getElementById("menu_content_fir");
            let wrapper = document.getElementsByClassName("header")[0];

            for (let i = 0; i < el.length; i++) {
                if (i == 1) {
                    el[i].addEventListener("mouseenter", function () {
                        firContent.style.animation = "aniHome 0.5s ease-in-out";
                        firContent.style.animationFillMode = "forwards";
                        content.style.display = "block";
                    });
                }

            }
            firContent.addEventListener("mouseleave", function () {
                firContent.style.animation = "aniReverseHome 0.5s ease-in-out";
                firContent.style.animationFillMode = "";
                setTimeout(() => {
                    content.style.display = "none";
                }, 300);
            });
            // wrapper.addEventListener("mouseleave", function () {
            //     firContent.style.animation = "aniReverseHome 0.5s ease-in-out";
            //     firContent.style.animationFillMode = "";
            //     setTimeout(() => {
            //         content.style.display = "none";
            //     }, 300);
            // });
        },

        showPhoneContent() {
            this.isFold = !this.isFold
        },

        clickPhoneMenuNames(v, index) {
            if (v.name != '产品') {
                this.$router.push(v.route)
                this.isFold = false
            }
        },


        watchViewResize() {
            const observer = new ResizeObserver((ob = []) => {
                const {clientWidth} = (ob[0] || {}).target;
                if (clientWidth < 900) {
                    this.showPhoneMenu = true
                    return;
                }
                this.showPhoneMenu = false
            });
            observer.observe(document.body);
        },

        handleMouseEnter(type) {
            if (type == '0' || type == '2' || type == '4' || type == '5') {
                let content = document.getElementById("menu_content");
                content.style.display = 'none'
                this.menuList = []
            } else {
                switch (type) {
                    case '1':
                        this.menuList = this.productMenuList
                        break
                    case '2':
                        this.menuList = []
                        break
                    case '3':
                        this.menuList = this.courseMenuList
                        break
                    case '4':
                        this.menuList = []
                        break
                    case '5':
                        // this.menuList = this.aboutMenuList
                        this.menuList = []
                        break
                    default:
                }
            }
        },

        handleMouseLeave(type) {
        },

        goRoute(route) {
            if (!route) {
                return
            }
            this.$router.push(route)
            let content = document.getElementById("menu_content");
            content.style.display = 'none'
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    z-index: 9999;
    max-width: 1920px;
    height: 70px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    width: 100%;
    background: #fff;

    .logo {
        width: 150px;
        margin-left: 120px;
        cursor: pointer;
    }

    .menu {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .menu-item {
            color: #888;
            text-align: center;
            font-family: "Source Han Sans CN";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            // line-height: normal;
            cursor: pointer;
            height: 1.5rem;
            margin-right: 40px;
            position: relative;
            z-index: 10;
        }

        .menu-item::after {
            content: "";
            width: 0;
            height: 3px;
            border-radius: 1px;
            background: #62A243;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            transition: 0.5s all ease-in-out;
        }

        .menu-item:hover::after {
            width: 100%;
        }

        .menu-item:hover {
            color: #2A2C2C;
        }
    }


    .right-icon-fold {
        font-size: 46px;
        margin-right: 10px;
        cursor: pointer;
    }

    .menu-phone-content {
        position: fixed;
        cursor: pointer;
        left: 0;
        top: 0;
        // top: 70px;
        width: 100%;
        height: 100vh;
        background: rgba(98, 162, 68, 0.9);
        z-index: 9999 !important;

        .menu-phone-content-wrapper {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            margin: 40px 10px;
            width: auto;
            color: #fff;
            font-size: 24px;
            font-weight: bolder;

            .menu-phone-content-wrapper-item {
                width: auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 30px 15px;
                cursor: pointer;
            }

            .desc-icon {
                display: none;
                animation: 0.5s ease-in-out;
            }

            .menu-phone-content-wrapper-item:hover .desc-icon {
                display: block;
                font-weight: bolder;
            }

            .menu-phone-content-wrapper-item-child {

                div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    width: auto;
                    margin: 20px 15px 20px 30px;
                }

                :hover .desc-icon {
                    display: block;
                    font-weight: bolder;
                }
            }
        }
    }
}

#menu_content {
    display: none;
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    z-index: 9;
    height: 0;
    height: calc(100vh - 70px);
}

#menu_content_fir {
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .menu-child-item {
        cursor: pointer;
        text-align: center;

        .menu-child-name {
            cursor: pointer;
            color: #2A2C2C;
            font-weight: bolder;
        }

        .menu-child-subtext {
            color: #888888;
            font-size: 12px;
            font-weight: bolder;
            line-height: 2rem;
        }
    }
}

@media only screen and (max-width: 900px) {
    .logo {
        margin-left: 10px !important;
    }

}

</style>

<style>
@supports ((-webkit-backdrop-filter: saturate(180%) blur(20px)) or (backdrop-filter: saturate(180%) blur(20px))) {
    #menu_mao {
        width: 100%;
        height: calc(100vh - 70px);
        /* background: rgba(0, 0, 0, 0.6); */
        background: rgba(255, 255, 255, 0.3);
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
    }
}

/* @supports ((-webkit-backdrop-filter: saturate(180%) blur(20px)) or (backdrop-filter: saturate(180%) blur(20px))) {
    #menu_mao_phone {
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        background: rgba(255, 255, 255, 0.3);
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
    }
} */
@keyframes aniHome {
    0% {
        height: 0;
    }

    100% {
        height: 350px;
    }
}

@keyframes aniReverseHome {
    0% {
        height: 350px;
    }

    100% {
        height: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/headerMenu.vue